import NumberInput from './NumberInput';

export default NumberInput;
